<div #topElement></div>
<nb-card>
  <nb-card-header>
    <div class="title">
      <span i18n="@@AddPatient" *ngIf="!PatientId">Add New Client</span>
      <span i18n="@@EditPatient" *ngIf="PatientId">Edit Client</span>
    </div>
  </nb-card-header>

  <nb-card-body [formGroup]="PatientForm">
    <ng-template #customNewTutorialContent>
      Let's create yourself as a client! We pre-filled these fields for you.
    </ng-template>

    <ng-template #customNewTutorialContent2>
      Press the Save Client to create this client and move to the next step. You will also be able to edit client
      details later.
    </ng-template>

    <div>
      <div class="row">
        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div i18n="@@GeneralInfo" class="subtitle">Contact Info</div>
            </nb-card-header>

            <nb-card-body>
              <div
                title="Adding new Clients"
                (next)="onTutorialNext1()"
                [joyrideStep]="TutorialIDs.NewPatientStep1"
                stepPosition="left"
                [stepContent]="customNewTutorialContent"
              >
                <input formControlName="Id" type="hidden" />

                <div class="form-group row">
                  <div i18n="@@Name" class="col-sm-3 label col-form-label">Name</div>
                  <div class="col-sm-1"></div>
                  <div class="col-sm-8">
                    <input
                      nbInput
                      formControlName="FirstName"
                      [status]="
                        FirstName?.errors?.required ||
                        FirstName?.hasError('minlength') ||
                        FirstName?.hasError('maxlength')
                          ? 'danger'
                          : 'primary'
                      "
                      type="text"
                      fullWidth
                      shape="semi-round"
                      i18n-placeholder="@@Name"
                      placeholder="Name"
                    />
                    <ngx-validation-message
                      i18n-label="@@Name"
                      label="Name"
                      [showMinLength]="FirstName?.hasError('minlength')"
                      [showMaxLength]="FirstName?.hasError('maxlength')"
                      [showRequired]="FirstName?.errors?.required && FirstName.touched"
                      minLength="3"
                      maxLength="50"
                    >
                    </ngx-validation-message>
                  </div>
                </div>
                <div class="form-group row">
                  <div i18n="@@LastName" class="col-sm-3 label col-form-label">Last Name</div>
                  <div class="col-sm-1"></div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      formControlName="LastName"
                      [status]="
                        LastName?.errors?.required || LastName?.hasError('minlength') || LastName?.hasError('maxlength')
                          ? 'danger'
                          : 'primary'
                      "
                      nbInput
                      fullWidth
                      shape="semi-round"
                      i18n-placeholder="@@LastName"
                      placeholder="Last Name"
                    />
                    <ngx-validation-message
                      i18n-label="@@LastName"
                      label="Last Name"
                      [showMinLength]="LastName?.hasError('minlength')"
                      [showMaxLength]="LastName?.hasError('maxlength')"
                      [showRequired]="LastName?.errors?.required && LastName.touched"
                      minLength="3"
                      maxLength="50"
                    >
                    </ngx-validation-message>
                  </div>
                </div>

                <div class="form-group row">
                  <div i18n="@@EmailAddress" class="col-sm-3 label col-form-label">Email Address</div>
                  <div class="col-sm-1"></div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      nbInput
                      fullWidth
                      shape="semi-round"
                      [status]="
                        EMail?.errors?.required ||
                        EMail?.hasError('pattern') ||
                        EMail?.hasError('minlength') ||
                        EMail?.hasError('maxlength')
                          ? 'danger'
                          : 'primary'
                      "
                      formControlName="EMail"
                      i18n-placeholder="@@EmailAddress"
                      placeholder="Email Address"
                    />
                    <ngx-validation-message
                      i18n-label="@@EmailAddress"
                      label="Email Address"
                      [showPattern]="EMail?.hasError('pattern') && EMail.touched"
                      [showRequired]="EMail?.errors?.required && EMail.touched"
                      min="1"
                      max="120"
                    >
                    </ngx-validation-message>
                  </div>
                </div>

                <div class="form-group row">
                  <div i18n="@@PhoneNumber" class="col-sm-3 label col-form-label">Mobile Number</div>
                  <div class="col-sm-1"></div>
                  <div class="col-sm-8">
                    <ngx-intl-tel-input
                      [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="true"
                      [searchCountryFlag]="true"
                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="CountryISO.UnitedStates"
                      [maxLength]="15"
                      [numberFormat]="PhoneNumberFormat.International"
                      [phoneValidation]="true"
                      name="PhoneNumber"
                      formControlName="PhoneNumber"
                      shape="semi-round"
                    ></ngx-intl-tel-input>
                    <ngx-validation-message
                      i18n-label="@@PhoneNumber"
                      label="Mobile Number"
                      [showPattern]="PhoneNumber?.invalid"
                      min="10"
                      max="15"
                    ></ngx-validation-message>
                  </div>
                </div>

                <div class="form-group row">
                  <div i18n="@@DateOfBirth" class="col-sm-3 label col-form-label">Date of Birth</div>
                  <div class="col-sm-1"></div>
                  <div class="col-sm-8">
                    <input
                      nbInput
                      i18n-placeholder="@@DateOfBirth"
                      fullWidth
                      shape="semi-round"
                      [status]="
                        DateOfBirth?.errors?.required ||
                        DateOfBirth?.hasError('minlength') ||
                        DateOfBirth?.hasError('maxlength')
                          ? 'danger'
                          : 'primary'
                      "
                      [nbDatepicker]="formpicker"
                      formControlName="DateOfBirth"
                    />
                    <nb-datepicker #formpicker></nb-datepicker>
                    <ngx-validation-message
                      i18n-label="@@DateOfBirth"
                      label="Date of Birth"
                      [showRequired]="DateOfBirth?.errors?.required && DateOfBirth.touched"
                    ></ngx-validation-message>
                  </div>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <div class="col-lg-6" [class.blockClick]="isTutorial === true">
          <nb-card>
            <nb-card-header>
              <div i18n="@@Address" class="subtitle">Address</div>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <div i18n="@@Address" class="col-sm-3 label col-form-label">Address</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    shape="semi-round"
                    [status]="
                      AddressLine1?.hasError('minlength') || AddressLine1?.hasError('maxlength') ? 'danger' : 'primary'
                    "
                    formControlName="AddressLine1"
                    i18n-placeholder="@@AddressLine1"
                    placeholder="Line 1"
                  />
                  <ngx-validation-message
                    i18n-label="@@AddressLine1"
                    [showMaxLength]="AddressLine1?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  >
                  </ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-3 label col-form-label"></div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    shape="semi-round"
                    formControlName="AddressLine2"
                    [status]="
                      AddressLine2?.hasError('minlength') || AddressLine2?.hasError('maxlength') ? 'danger' : 'primary'
                    "
                    i18n-placeholder="@@AddressLine2"
                    placeholder="Line 2"
                  />
                  <ngx-validation-message
                    i18n-label="@@AddressLine2"
                    label="Line 2"
                    [showMaxLength]="AddressLine2?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  >
                  </ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@Country" class="col-sm-3 label col-form-label">Country</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <nb-select
                    id="Country"
                    size="medium"
                    i18n-placeholder="@@Country"
                    placeholder="Country"
                    fullWidth
                    [status]="Country?.errors?.required || Country?.hasError('maxlength') ? 'danger' : 'primary'"
                    formControlName="Country"
                  >
                    <nb-option *ngFor="let item of Countries | async" [value]="item.name">{{ item.name }}</nb-option>
                  </nb-select>
                  <ngx-validation-message
                    i18n-label="@@Country"
                    label="Country"
                    [showMaxLength]="Country?.hasError('maxlength')"
                    minLength="3"
                    maxLength="1024"
                  >
                  </ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@PostalCode" class="col-sm-3 label col-form-label">Zip / Postal Code</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    fullWidth
                    shape="semi-round"
                    formControlName="ZipPostalCode"
                    i18n-placeholder="@@PostalCode"
                    placeholder="Zip / Postal Code"
                  />
                  <ngx-validation-message
                    i18n-label="@@PostalCode"
                    label="{{ PostalCodeInfoLabel }}"
                    [showMaxLength]="ZipPostalCode?.hasError('maxlength')"
                    minLength="3"
                    maxLength="25"
                  >
                  </ngx-validation-message>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row" [class.blockClick]="isTutorial === true">
        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div i18n="@@Preferences" class="subtitle">Preferences</div>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <div i18n="@@Gender" class="col-sm-3 label col-form-label">Gender</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <nb-radio-group formControlName="genderFemale" name="Gender">
                    <nb-radio i18n="@@Male" [value]="false">Male</nb-radio>
                    <nb-radio i18n="@@Female" [value]="true">Female</nb-radio>
                  </nb-radio-group>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@PreferredUnits" class="col-sm-3 label col-form-label">Preferred Units</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <div style="display: flex">
                    <nb-radio-group
                      formControlName="IsPreferredUnitImperial"
                      name="IsPreferredUnitImperial"
                      (valueChange)="onChangePreferredUnit()"
                    >
                      <nb-radio i18n="@@Metrics" [value]="false">Metrics</nb-radio>
                      <nb-radio i18n="@@Imperial" [value]="true">Imperial</nb-radio>
                    </nb-radio-group>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-4 label col-form-label">
                  Check In Request
                </div>
                <div class="col-sm-8">
                  <div style="display: flex">
                    <nb-radio-group
                      formControlName="checkInRequest"
                      name="checkInRequest"
                    >
                      <nb-radio [value]="true"
                        >Send Check In Requests</nb-radio
                      >
                      <nb-radio [value]="false"
                        >Don't send Check In Requests</nb-radio
                      >
                    </nb-radio-group>
                  </div>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div i18n="@@BiometricInfo" class="subtitle">BioMetric Info</div>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row">
                <div i18n="@@Height" class="col-sm-3 label col-form-label">Height</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <feet-and-inch
                    formControlName="Height"
                    [status]="Height?.errors?.required ? 'danger' : 'primary'"
                    [isImperial]="IsPreferredUnitImperial.value"
                  ></feet-and-inch>
                  <ngx-validation-message
                    i18n-label="@@Height"
                    label="Height"
                    [showRequired]="Height?.errors?.required && Height.touched"
                    maxLength="15"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@Weight" class="col-sm-3 label col-form-label">Weight</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <pounds-and-kg
                    formControlName="Weight"
                    [status]="Weight?.errors?.required ? 'danger' : 'primary'"
                    [isImperial]="IsPreferredUnitImperial.value"
                  ></pounds-and-kg>
                  <ngx-validation-message
                    i18n-label="@@Weight"
                    label="Weight"
                    [showRequired]="Weight?.errors?.required && Weight.touched"
                    minLength="3"
                    maxLength="15"
                  >
                  </ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@BMI" class="col-sm-3 label col-form-label">BMI</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    shape="semi-round"
                    readonly
                    value="{{ BMI }}"
                    i18n-placeholder="@@BMI"
                    placeholder="BMI"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@BodyFatPercent" class="col-sm-3 label col-form-label">Body Fat %</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    nbInput
                    shape="semi-round"
                    formControlName="BodyFat"
                    (keypress)="validateNumber($event)"
                    i18n-placeholder="@@BodyFatPercent"
                    placeholder="Body Fat %"
                  />
                  <ngx-validation-message
                    i18n-label="@@BodyFatPercent"
                    label="Body Fat %"
                    [showMin]="BodyFat?.errors?.min && BodyFat.touched"
                    [showMax]="BodyFat?.errors?.max && BodyFat.touched"
                    [showPattern]="BodyFat?.hasError('pattern')"
                    min="0"
                    max="100"
                  ></ngx-validation-message>
                </div>
              </div>

              <div class="form-group row">
                <div i18n="@@DateOfMeasure" class="col-sm-3 label col-form-label">Date of Measure</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8">
                  <input
                    [owlDateTime]="dt1"
                    nbInput
                    shape="semi-round"
                    [owlDateTimeTrigger]="dt1"
                    i18n-placeholder="@@DateOfMeasure"
                    placeholder="{{ MeasureDateLabel }}"
                    formControlName="DateOfMeasure"
                  />
                  <owl-date-time #dt1></owl-date-time>
                  <ngx-validation-message
                    i18n-label="@@DateOfMeasure"
                    label="Date of Measure"
                    [showRequired]="DateOfMeasure?.errors?.required && DateOfMeasure.touched"
                  ></ngx-validation-message>
                </div>
              </div>
            </nb-card-body>

            <nb-card-footer *ngIf="PatientId > 0">
              <button i18n="@@Goals" nbButton type="submit" (click)="Goals()">Goals</button>
            </nb-card-footer>
          </nb-card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <nb-card>
            <nb-card-header>
              <div class="subtitle">Billing & Packages</div>
            </nb-card-header>

            <nb-card-body>
              <div class="form-group row" *ngIf="subscriptionData?.items.length > 0">
                <div i18n="@@Height" class="col-sm-3 label col-form-label">Invite to Subscription</div>
                <div class="col-sm-1"></div>
                <div class="col-sm-8" *ngIf="subscriptionData">
                  <nb-select class="w-100" [formControl]="SubscriptionId">
                    <nb-option *ngFor="let option of subscriptionData.items" [value]="option.id">
                      {{ option.invoiceItems[0].itemDescription }}
                    </nb-option>
                  </nb-select>
                  <ngx-validation-message
                    i18n-label="@@Height"
                    label="Height"
                    [showRequired]="Height?.errors?.required && Height.touched"
                    maxLength="15"
                  ></ngx-validation-message>
                </div>
              </div>
              <div *ngIf="subscriptionData?.items.length === 0">
                No package found, to invite a client to a package/subscription, please go to Billing & Packages and create a new package.
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <!-- <div
        class="row"
        *ngIf="!PatientId || PatientId == 0"
        [class.blockClick]="isTutorial === true"
      >
        <div class="col-lg-6">
          <temp-app-goal-list
            #Goals
            [IsPreferredUnitImperial]="IsPreferredUnitImperial.value"
            [Goals]="tempGoals"
          >
          </temp-app-goal-list>
        </div>
      </div>
-->
    </div>
  </nb-card-body>

  <nb-card-footer [class.blockClick]="isTutorial === true">
    <div class="actions float-left">
      <ng-template #customDoneTutorialButton></ng-template>

      <div
        [class.in-tutorial]="joyrideService.isTourInProgress()"
        title="Adding new Clients"
        [joyrideStep]="TutorialIDs.NewPatientStep2"
        stepPosition="left"
        [stepContent]="customNewTutorialContent2"
      >
        <button
          #saveElement
          i18n="@@SavePatient"
          nbButton
          type="submit"
          class="btn-circle btn-xl btn-main"
          (click)="SavePatient()"
          [disabled]="!PatientForm.valid"
        >
          Save Client
        </button>
      </div>
      <div [class.padding-in-tutorial]="joyrideService.isTourInProgress()">
        <button i18n="@@Back" nbButton type="button" status="basic" class="back btn-circle btn-xl" (click)="Back()">
          Back
        </button>
      </div>
    </div>
  </nb-card-footer>
</nb-card>
